import React, { useState, useEffect } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, TextField, Button } from '@mui/material';
import useApiManager from '../../../../utils/Api/apiManager';
import { useParams } from 'react-router-dom';

function LinkAttachDialog({ open, onClose, fetchLeadAttachments, attachment }) {
    const [name, setName] = useState('');
    const [url, setUrl] = useState('');
    const { leadId } = useParams();
    const { post, put } = useApiManager();

    useEffect(() => {
        if (attachment) {
            setName(attachment.fileName || '');
            setUrl(attachment.uri || '');
        }
    }, [attachment]);

    const handleAttach = async () => {
        const formData = new FormData();
        formData.append('Name', name);
        formData.append('Uri', url);

        const apiUrl = `/leads/${leadId}/attachments/link`;

        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        };
        try {
            if(attachment.id != null) {
                await put(`/leads/${leadId}/attachments/${attachment.id}`, formData, config);
            }
            else {
                await post(apiUrl, formData, config);
            }

        } catch (error) {
            console.error('Error attaching link:', error);
            throw error; // Handle the error appropriately
        }
        fetchLeadAttachments();
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Attach Link</DialogTitle>
            <DialogContent>
                <TextField
                    margin="dense"
                    label="Enter URL:"
                    type="url"
                    fullWidth
                    variant="outlined"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                />
                <TextField
                    margin="dense"
                    label="Name:"
                    type="text"
                    fullWidth
                    variant="outlined"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleAttach} color="primary">
                    Attach
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default LinkAttachDialog;
